export default "__VITE_ASSET__v91B4H6w__"